var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rules",staticClass:"rules",class:{'rules--error':_vm.error.length}},[_vm._t("default"),_c('div',{staticClass:"rules-error"},_vm._l((_vm.error),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(_vm.$t(item.msg)))])}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }